import React from 'react';
import ConnectedInjectIntl from 'Containers/ConnectedInjectIntl';

class TextInput extends React.PureComponent {
  componentDidMount() {
    const { updateFieldValidity, value } = this.props;
    if (updateFieldValidity)
      updateFieldValidity(value, this.textInput.validity);
  }

  componentDidUpdate(prevProps) {
    if (this.props.focusedField === this.props.fieldName) {
      this.textInput.focus();
    }

    // Sometimes, a text field needs to match another one.
    // If this one does and the other field has changed,
    // let Redux know there’s something new to interpret.
    if (
      prevProps.fieldToMatch &&
      this.props.fieldToMatch &&
      prevProps.fieldToMatch.value !== this.props.fieldToMatch.value &&
      // The only time both would change is if the form was cleared.
      prevProps.value === this.props.value
    ) {
      this.props.handleChange(this.textInput);
    }
  }

  static getFieldStyle(fieldStyle, fieldSize, errorClass) {
    let styleClass = ` FormInput--size-${fieldSize || 'large'}`;
    if (fieldStyle === 'underline')
      return `${styleClass} FormInput--text-underline`;
    return `${styleClass}${
      errorClass ? errorClass : ''
    } FormInput--text FormInput--text-single`;
  }

  render() {
    const {
      fieldStyle,
      name,
      fieldName,
      errorClass,
      value,
      placeholderId,
      autocomplete,
      inputAction,
      type,
      handleChange,
      handleFocus,
      readOnly,
      fieldSize,
      maxLength,
      minLength,
      pattern,
      prefixIcon,
      autocapitalize,
      disabled,
    } = this.props;
    const styleClass = TextInput.getFieldStyle(
      fieldStyle,
      fieldSize,
      errorClass
    );
    return (
      <ConnectedInjectIntl
        messageIds={[placeholderId]}
        render={messages => (
          <div className={`FormInput FormInput--${fieldName}${styleClass}`}>
            {prefixIcon}
            <input
              ref={input => {
                this.textInput = input;
              }}
              type={type || 'text'}
              id={`input-${name}`}
              name={name}
              className="FormInput__input"
              value={value}
              placeholder={messages[placeholderId]}
              onChange={e => handleChange(e.target)}
              onFocus={e => (handleFocus ? handleFocus(e) : null)}
              onBlur={e => (handleFocus ? handleFocus(e) : null)}
              maxLength={maxLength}
              minLength={minLength}
              pattern={pattern}
              autoComplete={autocomplete}
              readOnly={readOnly}
              autoCapitalize={autocapitalize}
              disabled={disabled}
            />
            {inputAction}
          </div>
        )}
      />
    );
  }
}

export default TextInput;
